<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import zh_CN from "utils/zh_CN";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  computed: mapGetters(["statusDic"]),
  methods: mapActions(["setStatusDic"]),
  created() {
    this.$validator.localize("cn", zh_CN);
    if (this.statusDic === null) {
      this.setStatusDic();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue